import Onedio from "../pages/Onedio";
import Mynet from "../pages/Mynet";
import Mackolik from "../pages/Mackolik";
import Webtekno from "../pages/Webtekno";
import Yemekcom from "../pages/Yemekcom";
import Hissenet from "../pages/Hissenet";
import { useLanguage } from "../contexts/LanguageContext";


export const mainMenu = [
  {
    id: 1,
    name: 'Onedio',
    link: 'onedio',
    component: <Onedio key={1} />
  },
  {
    id: 2,
    name: 'Mynet',
    link: 'mynet',
    component: <Mynet key={2} />
  },
  {
    id: 3,
    name: 'Maçkolik',
    link: 'mackolik',
    component: <Mackolik key={3} />
  },
  {
    id: 4,
    name: 'Webtekno',
    link: 'webtekno',
    component: <Webtekno key={4} />
  },
  {
    id: 5,
    name: 'Yemek.com',
    link: 'yemekcom',
    component: <Yemekcom key={5} />
  },
  {
    id: 6,
    name: 'Hissenet',
    link: 'hissenet',
    component: <Hissenet key={6} />
  },
];

export const useSubMenu = () => {
  const { language } = useLanguage();

  return [
    {
      id: 1,
      name: language === "TR" ? "Datalar" : "Data",
      link: "datalar",
      product: ["onedio", "mynet", "mackolik", "yemekcom", "hissenet"]
    },
    {
      id: 2,
      name: language === "TR" ? "Push Notification" : "Push Notification",
      link: "push",
      product: ["mackolik"]
    },
    {
      id: 3,
      name: language === "TR" ? "İçerikler" : "Contents",
      link: "icerikler",
      product: ["onedio", "mynet", "mackolik", "yemekcom"]
    },
    {
      id: 11,
      name: language === "TR" ? "Kategoriler" : "Categories",
      link: "kategoriler",
      product: ["yemekcom"]
    },
    {
      id: 4,
      name: language === "TR" ? "Projeler" : "Projects",
      link: "projeler",
      product: ["onedio", "mynet", "mackolik", "webtekno", "yemekcom", "hissenet"]
    },
    {
      id: 10,
      name: language === "TR" ? "Display" : "Display",
      link: "display",
      product: ["mynet", "mackolik", "yemekcom"]
    },
    {
      id: 5,
      name: language === "TR" ? "Videolar" : "Videos",
      link: "videolar",
      product: ["onedio", "mackolik", "yemekcom"]
    },
    {
      id: 6,
      name: language === "TR" ? "Yemek" : "Food",
      link: "yemekler",
      product: ["onedio"]
    },
    {
      id: 7,
      name: language === "TR" ? "Vitrin" : "Vitrin",
      link: "vitrin",
      product: ["onedio", "mynet"]
    },
    {
      id: 8,
      name: language === "TR" ? "Display & Programatik" : "Display & Programmatic",
      link: "display-programatik",
      product: ["onedio"]
    },
    {
      id: 9,
      name: language === "TR" ? "Sosyal Medya" : "Social Media",
      link: "sosyal-medya",
      product: ["mackolik"]
    },
  ];
};

export const colorPalette = ['#FFD2A6', '#FFB7B7', '#C3EEDF', '#D6DDFC', '#8D97C7', '#AD8DC7', '#C78D90'];
